import { render, staticRenderFns } from "./RfTester.vue?vue&type=template&id=b5b0ccc4"
import script from "./RfTester.vue?vue&type=script&lang=js"
export * from "./RfTester.vue?vue&type=script&lang=js"
import style0 from "./RfTester.vue?vue&type=style&index=0&id=b5b0ccc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports